import { TransformedUseCase } from '@repo/editor/src/types';
import { create } from 'zustand';

import { getUseCaseData } from 'global/utils/templates/getUseCaseData';

interface UseCasesStoreState {
  initialized: boolean;
  useCases: TransformedUseCase[];

  initialize: () => void;
  setUseCases: (useCases: TransformedUseCase[]) => void;
}

export const useCasesStore = create<UseCasesStoreState>((set, get) => ({
  initialized: false,
  useCases: [],

  initialize: async (): Promise<void> => {
    if (!get().initialized) {
      const useCasesData = await getUseCaseData();
      set({ useCases: useCasesData });
      set({ initialized: true });
    }
  },
  setUseCases: (useCases) => {
    set({
      useCases,
    });
  },
}));

export const useCasesStoreSelector = {
  initialize: (state: UseCasesStoreState) => state.initialize,
  useCases: (state: UseCasesStoreState) => state.useCases,
  setUseCases: (state: UseCasesStoreState) => state.setUseCases,
};
